/**
 * Global application configuration.
 * Can store run-time options, API urls, paths, execution flags and so on.
 * Automatically loaded on application initialization and available as app.config.
 */

'use strict';

// public
module.exports = {

    // enable system info about player activity
    debug: true,

    // force single player mode on this devices
    preventMultiplePlayer: [],

    // disable sound options in this models
    disableSoundOptions: ['emulator_stb', 'emulator'],

    pipDisableModels: [
        'emulator',
        'emulator_stb',
        'AndroidAPP',
        'AndroidSTB',
        'MAG250',
        'MAG322',
        'MAG323',
        'MAG324',
        'MAG325',
        'MAG275',
        'MAG349',
        'IM2100',
        'IM2101',
        'IM2100V',
        'M2101',
        'IM2101V',
        'AuraHD4',
        'IM2102'
    ],

    disableSpinnerAnimation: ['MAG256', 'MAG257', 'MAG250'],

    // will be set in runtime
    pipSupport: true,

    // if we call play function and do not catch onPlayStart, onError or onPlayEnd events till this timeout happen we emit error event/ ms
    waitUntilPlayEvent: 15000
};
